import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import i18n, { initLocalization, changeLanguage } from "../localization";

const fallbackLocalizationValue = {
  t: (...args) => i18n.t(...args),
  locale: i18n.locale || "en",
  setLocale: () => {},
};

const LocalizationContext = createContext(fallbackLocalizationValue);

export const LocalizationProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(i18n.locale || "en");

  useEffect(() => {
    const resolvedLocale = initLocalization();
    setLocaleState(resolvedLocale);
  }, []);

  const setLocale = useCallback((newLocale) => {
    if (!newLocale) return;
    changeLanguage(newLocale);
    setLocaleState(newLocale);
  }, []);

  const value = useMemo(
    () => ({ t: i18n.t, locale, setLocale }),
    [locale, setLocale]
  );

  return (
    <LocalizationContext.Provider value={value}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);
